const permissions = {
  MANAGE_USERS: 'manage-users',
  VIEW_REPORTS: 'view-reports',
  VIEW_ALL_EMPLOYEES: 'view-all-employees',
  VIEW_ALL_PROJECTS: 'view-all-projects', // default view all projects
  CAN_RE_SYNC: 'can-re-sync',
};

const permissionsList = [
  {
    id: permissions.MANAGE_USERS,
    name: 'Manage Users',
    description: 'Manage Users & Roles',
  },
  {
    id: permissions.VIEW_REPORTS,
    name: 'View Reports',
    description: 'View Reports',
  },
  {
    id: permissions.VIEW_ALL_EMPLOYEES,
    name: 'View All Employees',
    description: 'View All Employees',
  },
  {
    id: permissions.VIEW_ALL_PROJECTS,
    name: 'Default View All Projects',
    description: 'Default view all projects',
  },
  {
    id: permissions.CAN_RE_SYNC,
    name: 'Can Re-Sync',
    description: 'Triggers a HubSpot re-sync',
  },
];

const arrayPermissions = Object.values(permissions);

const hasPermission = (userPermissions, requiredPermission) => {
  return userPermissions.includes(requiredPermission);
};

const hasSomePermission = (userPermissions, requiredPermissions) => {
  return requiredPermissions?.some((permission) =>
    userPermissions.includes(permission),
  );
};

const hasAllPermissions = (userPermissions, requiredPermissions) => {
  return requiredPermissions?.every((permission) =>
    userPermissions.includes(permission),
  );
};

const getPermissionName = (permission) => {
  return permissionsList.find((p) => p.id === permission)?.name;
};

module.exports = {
  permissions,
  arrayPermissions,
  permissionsList,
  hasPermission,
  hasSomePermission,
  hasAllPermissions,
  getPermissionName,
};
